<div
  *ngIf="balancesResponse$ | async as balances"
  class="md:grid md:grid-cols-2 md:grid-rows-2 gap-4 xl:grid-cols-3 xl:grid-rows-1"
>
  <div
    *ngIf="currency === 'eur'"
    class="shadow-wdgt border-l-primary border-l-4 rounded-wdgt bg-white border border-border-d p-16px mb-16px md:mb-0"
  >
    <div class="text-22px text-secondary">EUR</div>
    <div class="mt-16px text-22px text-right">
      <ib-data-view
        [dataType]="DATA_TYPE.NUMBER"
        [val]="balances.v?.balance.EUR"
      ></ib-data-view>
    </div>
  </div>

  <div
    *ngIf="currency === 'gbp'"
    class="shadow-wdgt border-l-primary border-l-4 rounded-wdgt bg-white border border-border-d p-16px mb-16px md:mb-0"
  >
    <div class="text-22px text-secondary">GBP</div>
    <div class="mt-16px text-22px text-right">
      <ib-data-view
        [dataType]="DATA_TYPE.NUMBER"
        [val]="balances.v?.balance.GBP"
      ></ib-data-view>
    </div>
  </div>
  <div
    *ngIf="currency === 'usd'"
    class="shadow-wdgt border-l-primary border-l-4 rounded-wdgt bg-white border border-border-d p-16px mb-16px md:mb-0"
  >
    <div class="text-22px text-secondary">USD</div>
    <div class="mt-16px text-22px text-right">
      <ib-data-view
        [dataType]="DATA_TYPE.NUMBER"
        [val]="balances.v?.balance.USD"
      ></ib-data-view>
    </div>
  </div>
  <div
    class="shadow-wdgt rounded-wdgt bg-white border border-border-d p-16px mb-16px md:mb-0"
  >
    <div class="text-22px text-secondary">
      {{ 'page.dashboard.interest-to-date' | transloco }}
    </div>
    <div class="mt-16px text-22px text-right">
      <ib-data-view
        [dataType]="DATA_TYPE.NUMBER"
        [val]="balances.v?.yield"
      ></ib-data-view>
      <!-- <small *ngIf="balances.v?.interestToDatePrct"
        >(<ib-data-view
          [dataType]="DATA_TYPE.PERCENT"
          [val]="balances.v?.interestToDatePrct"
        ></ib-data-view
        >%)</small
      > -->
    </div>
  </div>

  <div
    class="shadow-wdgt rounded-wdgt flex justify-center items-center bg-white border border-border-d p-16px"
  >
    <button
      mat-button
      class="ib-btn ib-btn-h-auto ib-btn-primary"
      (click)="openModal()"
    >
      {{ 'page.dashboard.deposit-btn' | transloco }}
    </button>
  </div>
</div>
